var map = {
	"./china.svg": "4b36",
	"./france.svg": "08bb",
	"./germany.svg": "aac1",
	"./greece.svg": "1ea1",
	"./italy.svg": "0834",
	"./sweden.svg": "80dc",
	"./uk.svg": "b5c9",
	"./usa.svg": "9d60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6053";